module.exports = __webpack_public_path__ + "img/wx.db17d008.jpg";